$(function () {
  $('.product-form').submit(function (e) {
    e.preventDefault() // avoid to execute the actual submit of the form.
    $('.minicart').removeClass('active')
    $('body').css('overflow-y', 'unset')
    var form = $(this)
    var actionUrl = form.attr('action')
    $('.product--cart__button').addClass('loading')
    $.ajax({
      type: 'POST',
      url: actionUrl,
      data: form.serialize(), // serializes the form's elements.
      dataType: 'json',
      success: function (data) {
        ReloadDataCart()
      },
      error: function (XMLHttpRequest, textStatus, message) {
        alert("You can't add item to cart")
        $('.product--cart__button').removeClass('loading')
      },
    })
  })

  // plus quantity
  $('body').on('click', '.lop__count-button--plus', function (e) {
    e.preventDefault() // avoid to execute the actual submit of the form.
    var varian_id = $(this).closest('.ui-mini-cart-product-card').attr('data-varial-id')
    var quantity = parseInt($(this).prev().val()) + 1
    $(this).addClass('loader')
    ChangeDataCart(varian_id, quantity)
  })

  // minus quantity
  $('body').on('click', '.lop__count-button--minus', function (e) {
    e.preventDefault() // avoid to execute the actual submit of the form.
    var varian_id = $(this).closest('.ui-mini-cart-product-card').attr('data-varial-id')
    var quantity = parseInt($(this).next().val()) - 1
    $(this).addClass('loader')
    ChangeDataCart(varian_id, quantity)
  })

  $('body').on('change', '.cart__count-quantity', function (e) {
    var varian_id = $(this).closest('.ui-mini-cart-product-card').attr('data-varial-id')
    var quantity = parseInt($(this).val())
    ChangeDataCart(varian_id, quantity)
  })

  $('body').on('click', '.removeminicart', function (e) {
    var varian_id = $(this).closest('.ui-mini-cart-product-card').attr('data-varial-id')
    ChangeDataCart(varian_id, 0)
  })

  $('body').on('click', '.header--items__cart', function (e) {
    e.preventDefault() // avoid to execute the actual submit of the form.
    if (!$('.minicart').hasClass('active')) {
      $('body').css('overflow-y', 'hidden')
    }
    $('.minicart').toggleClass('active')
  })

  $('body').on('click', '.close__minicart', function (e) {
    $('.minicart').removeClass('active')
    $('body').css('overflow-y', 'unset')
  })

  $('body').on('click', '.overflow', function (e) {
    $('.minicart').removeClass('active')
    $('body').css('overflow-y', 'unset')
  })

  const renderShowRoomProductInCartCount = arr => {
    $('.show-room_products_list .show-room_products_item_add_cart .badge').hide()
    arr?.forEach(function (d) {
      $('.show-room_products_list')
        .find(`.show-room_products_item_add_cart[ids="${d.id}"] .badge`)
        .show()
        .html(d.quantity)
    })
  }

  $('body').on('click', '.activity-combo-buy__image', function (e) {
    e.stopPropagation()
    e.preventDefault()
    const ids = $(this).attr('ids')?.split(',') || []
    if (!ids.length) return
    const items = ids.map(d => ({ id: +d, quantity: 1 }))
    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    })
      .then(response => {
        return response.json()
      })
      .then(res => {
        ReloadDataCart(renderShowRoomProductInCartCount)
      })
      .catch(error => {
        alert("You can't add item to cart")
      })
  })

  /*
    varianid: string 
    number: string
  */
  function ChangeDataCart(varianid, number) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: varianid, quantity: number }, // serializes the form's elements.
      dataType: 'json',
      success: function (data) {
        varianid = parseInt(varianid)
        number = parseInt(number)
        for (var i in data.items) {
          if (data.items[i].id === varianid) {
            if (data.items[i].quantity < number) {
              text = 'You can only add ' + data.items[i].quantity + ' of this item to your cart.'
              alert(text)
              break
            }
          }
        }
        ReloadDataCart(renderShowRoomProductInCartCount)
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        alert(textStatus)
      },
    })
  }

  /*
    return html minicart
  */
  const specialType = ['Warranty', 'Gift']

  function ReloadDataCart(cb) {
    $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function (cart) {
        if (cart.item_count > 0) {
          $('.minicart').removeClass('empty')
        } else {
          $('.minicart').addClass('empty')
        }
        cb?.(cart?.items || [])
        // update item account
        $('.header--items__cart-count').html(cart.item_count)
        $('.ui-mini-cart__info-items-count').html(cart.item_count)
        var html_minicart = ''
        $('.cart__button--price').html('$' + cart.total_price / 100)
        for (var j in cart.items) {
          const productType = cart.items[j].product_type
          // open
          html_minicart += '<div class="ui-mini-cart-product-card" data-varial-id="' + cart.items[j].variant_id + '">'
          html_minicart += '<div class="ui-mini-cart-product-card__content">'
          html_minicart += '<div class="ui-mini-cart-product-card__header">'
          // gender title
          html_minicart += '<div class="ui-mini-cart-product-card__title">'
          html_minicart += '<div class="cart__item-copy-wrap">'
          if (specialType.includes(productType)) {
            html_minicart += '<div class="lop__copy cart__item-name">' + cart.items[j].product_title + '</div>'
          } else {
            const unit = cart.items[j].variant_title.indexOf(' ') === -1 ? 'Gallon' : ''
            html_minicart +=
              '<a class="lop__copy cart__item-name" href="' +
              cart.items[j].url +
              '">' +
              cart.items[j].product_title +
              '</a>'
            html_minicart +=
              '<p class="lop__copy--small cart__item-sub-name">' + cart.items[j].variant_title + ` ${unit}</p>`
          }

          html_minicart += '</div>'
          html_minicart += '</div>'
          // gender remove
          html_minicart += '<div class="removeminicart">remove</div>'
          html_minicart += '</div>'
          html_minicart += '</div>'
          // gender images quality
          html_minicart += '<div class="ui-mini-cart-product-card__content">'
          html_minicart += '<div class="ui-mini-cart-product-card__content-wrapper">'
          if (specialType.includes(productType)) {
            html_minicart += '<div class="cart__item-link-wrap" >'
            html_minicart += '<img class="cart__item-img" src="' + cart.items[j].image + '" alt=" ">'
            html_minicart += '</div>'
          } else {
            html_minicart += '<a class="cart__item-link-wrap" href="' + cart.items[j].url + '">'
            html_minicart += '<img class="cart__item-img" src="' + cart.items[j].image + '" alt=" ">'
            html_minicart += '</a>'
          }
          html_minicart += '</div>'
          //gender price and quality
          html_minicart += '<div class="ui-mini-cart-product-card__description">'
          html_minicart += '<div class="ui-mini-cart-product-card__shipping-restrictions"></div>'
          html_minicart += '<div class="ui-mini-cart-product-card__bottom">'
          html_minicart += '<div class="ui-mini-cart-product-card__price">$' + cart.items[j].price / 100 + '</div>'
          // if(cart.items[j].final_price != cart.items[j].original_price) {
          //   html_minicart += '<div class="ui-mini-cart-product-card__price ui-mini-cart-product-card__final-price">$' + cart.items[j].final_price / 100 + '</div>'
          //   html_minicart += '<div class="ui-mini-cart-product-card__price original">' + cart.items[j].original_price / 100  + '</div>'
          // } else {
          //   html_minicart += '<div class="ui-mini-cart-product-card__price">$' + cart.items[j].final_price / 100 + '</div>'
          // }
          if (!specialType.includes(productType)) {
            html_minicart += '<div class="ui-mini-cart-product-quantity">'
            html_minicart += '<div class="lop__count-wrap cart__table-count-wrap">'
            html_minicart += '<button class="lop__count-button lop__count-button--minus cart__count-button"></button>'
            html_minicart +=
              '<input class="lop__count-quantity cart__count-quantity" type="number" name="updates[]" value="' +
              cart.items[j].quantity +
              '" min="0">'
            html_minicart += '<button class="lop__count-button lop__count-button--plus cart__count-button"></button>'
            html_minicart += '</div>'
            html_minicart += '</div>'
          }
          html_minicart += '</div>'
          html_minicart += '</div>'
          html_minicart += '</div>'
          // end open
          html_minicart += '</div>'
        }
        const summaryDetails = `<div class="cell">
        <div>Subtotal: ${cart?.item_count} ${cart?.item_count > 1 ? 'items' : 'item'}</div>
        <div>$${cart.original_total_price / 100}</div>
      </div>
      <div class="cell">
        <div>Estimated Shipping</div>
        ${cart.total_price > 5000 ? '<div>Free</div>' : '<div>Free shipping orders over 50$</div>'}
      </div>
      ${
        cart.total_discount != 0
          ? `<div class="cell">
      <div>Discounts & Promotions</div>
      <div class="total-discount-price">-$${cart.total_discount / 100}</div>
    </div>`
          : ''
      }
      ${
        cart.total_price
          ? `<div class="cell">
      <div>Estimated total</div>
      <div class="total-result-price">$${cart.total_price / 100}</div>
    </div>`
          : ''
      }`

        $('.cart__content-wrap').html(html_minicart)
        $('.ui-mini-cart__summary .details').html(summaryDetails)
        $('.product--cart__button').removeClass('loading')
        $('.minicart').addClass('active')
        $('body').css('overflow-y', 'hidden')
      },
    })
  }
})
